<template>
  <div class="ov-page">
    <!-- ===== EN-TÊTE : ACCUEIL + FILTRE ===== -->
    <div class="dbb-head">
      <div>
        <div class="dbb-head__date">{{ currentDate }}</div>
        <h1 class="dbb-head__title">Bienvenue, {{ $store.state.userAuthentified.prenoms || $store.state.userAuthentified.nom }}</h1>
        <div v-if="$store.state.userAuthentified.lastConnection" class="dbb-head__sub">
          Dernière connexion : {{ $store.state.userAuthentified.lastConnection }}
        </div>
      </div>

      <div class="dbb-filters">
        <select v-model="dateSelected" class="ov-select" aria-label="Période">
          <option :value="null" disabled>Filtrer par date</option>
          <option v-for="(item, index) in dateFilterList" :key="index" :value="item.title">{{ item.title }}</option>
        </select>
        <template v-if="dateSelected === 'Periodique'">
          <input v-model="dateDebut" type="date" class="ov-input" aria-label="Date de début" title="Date de début" />
          <input v-model="dateFin" type="date" class="ov-input" aria-label="Date de fin" title="Date de fin" />
        </template>
        <input
          v-if="dateSelected === 'À une date précise'"
          v-model="datePrecise"
          type="date"
          class="ov-input"
          aria-label="Date précise"
          title="Date précise"
        />
        <button type="button" class="ov-btn ov-btn--primary" :disabled="!canApplyFilter || filtering" @click="applyFilterReservation">
          <v-progress-circular v-if="filtering" indeterminate size="16" width="2"></v-progress-circular>
          <v-icon v-else small>mdi-magnify</v-icon>
          Appliquer
        </button>
      </div>
    </div>

    <!-- ===== PÉRIODE FILTRÉE ===== -->
    <section v-if="isFilterApply" class="dbb-section">
      <div class="dbb-section__head">
        <h2 class="dbb-section__title">Statistiques filtrées</h2>
        <span class="ov-badge ov-badge--navy ov-badge--plain">{{ filterLabel }}</span>
        <button type="button" class="ov-icon-btn dbb-section__close" title="Retirer le filtre" @click="clearFilter">
          <v-icon small>mdi-close</v-icon>
        </button>
      </div>
      <statsBagagisteWidgetVue
        chart-id="bagagiste-filtre"
        :data-statistic-bag-station="appliedPeriod === 'Periodique' ? periodStatisticBags : mainlyDateStatisticBags"
      ></statsBagagisteWidgetVue>
    </section>

    <!-- ===== AUJOURD'HUI ===== -->
    <section class="dbb-section">
      <div class="dbb-section__head">
        <h2 class="dbb-section__title">Statistiques journalières</h2>
        <span class="ov-badge ov-badge--success">Aujourd'hui</span>
      </div>
      <statsBagagisteWidgetVue chart-id="bagagiste-jour" :data-statistic-bag-station="dailyStatisticBags"></statsBagagisteWidgetVue>
    </section>

    <!-- ===== ANNÉE ===== -->
    <section class="dbb-section">
      <div class="dbb-section__head">
        <h2 class="dbb-section__title">Statistiques annuelles</h2>
        <span class="ov-badge ov-badge--navy ov-badge--plain">{{ new Date().getFullYear() }}</span>
      </div>
      <statsBagagisteWidgetVue chart-id="bagagiste-annee" :data-statistic-bag-station="annualStatisticBags"></statsBagagisteWidgetVue>
    </section>

    <v-alert class="myalert alert-success" type="success" width="350px" dismissible>{{ successMsg }}</v-alert>
    <v-alert class="myalert alert-error" type="error" width="350px" dismissible>{{ errorMsg }}</v-alert>
  </div>
</template>

<script>
import axios from "axios";
import {
  HEADERS,
  API_STATISTIQUE_BAGAGES,
} from "@/components/globalConfig/globalConstConfig";
import statsBagagisteWidgetVue from "./widgets/statsBagagisteWidget.vue";
import { showErrorMessage } from "../messages/messageProcess.js";

export default {
  name: "DashboardBagagiste",

  components: {
    statsBagagisteWidgetVue,
  },

  data() {
    return {
      successMsg: null,
      errorMsg: null,
      filtering: false,

      dateFilterList: [
        { title: "Periodique", value: "period" },
        { title: "À une date précise", value: "date" },
      ],
      dateSelected: null,
      // Période réellement affichée (le sélecteur peut changer sans relancer la recherche)
      appliedPeriod: null,
      isFilterApply: false,

      dataToSend: {
        data: {
          gareTransportDesignation: null,
          gareDesignation: null,
          dateGiven: null,
          period: {
            dateDebut: null,
            dateFin: null,
          },
        },
      },

      dailyStatisticBags: null,
      annualStatisticBags: null,
      periodStatisticBags: null,
      mainlyDateStatisticBags: null,

      dateDebut: null,
      dateFin: null,
      datePrecise: null,
    };
  },

  computed: {
    currentDate() {
      return new Date().toLocaleDateString("fr-FR", {
        weekday: "long", day: "numeric", month: "long", year: "numeric",
      });
    },

    canApplyFilter() {
      if (this.dateSelected === "Periodique") return !!(this.dateDebut && this.dateFin);
      if (this.dateSelected === "À une date précise") return !!this.datePrecise;
      return false;
    },

    filterLabel() {
      return this.appliedPeriod === "Periodique"
        ? `Du ${this.formatDate(this.dateDebut)} au ${this.formatDate(this.dateFin)}`
        : `Le ${this.formatDate(this.datePrecise)}`;
    },
  },

  methods: {
    showError(message) {
      this.errorMsg = message;
      showErrorMessage();
    },

    // Appel des statistiques bagages pour une période ("jour", "annuel", "period", "date")
    async fetchBagStatistics(period) {
      this.dataToSend.data.gareDesignation = this.$store.state.userAuthentified.gareDesignation;
      this.dataToSend.data.gareTransportDesignation = this.$store.state.userAuthentified.gareDesignation;
      try {
        const response = await axios.post(API_STATISTIQUE_BAGAGES(period), this.dataToSend, {
          headers: HEADERS(this.$store.state.userAuthentified.token),
        });
        if (response.status == 200 && response.data.status.code == 800) {
          return response.data.item;
        }
        this.showError(response.data && response.data.status ? response.data.status.message : "Erreur lors du chargement des statistiques.");
      } catch (e) {
        this.showError((e && e.message) || "Erreur réseau lors du chargement des statistiques.");
      }
      return null;
    },

    // APPLIQUER LA RECHERCHE PAR FILTRE (DATES VÉRIFIÉES AVANT L'APPEL)
    async applyFilterReservation() {
      if (!this.canApplyFilter) {
        this.showError(
          this.dateSelected === "Periodique"
            ? "Renseignez la date de début et la date de fin."
            : "Renseignez la date."
        );
        return;
      }
      const isPeriod = this.dateSelected === "Periodique";
      this.dataToSend.data.period.dateDebut = isPeriod ? this.formatDate(this.dateDebut) : null;
      this.dataToSend.data.period.dateFin = isPeriod ? this.formatDate(this.dateFin) : null;
      this.dataToSend.data.dateGiven = isPeriod ? null : this.formatDate(this.datePrecise);

      this.filtering = true;
      const stats = await this.fetchBagStatistics(isPeriod ? "period" : "date");
      this.filtering = false;

      if (stats) {
        if (isPeriod) {
          this.periodStatisticBags = stats;
        } else {
          this.mainlyDateStatisticBags = stats;
        }
        this.appliedPeriod = this.dateSelected;
        this.isFilterApply = true;
      }
    },

    clearFilter() {
      this.isFilterApply = false;
      this.appliedPeriod = null;
      this.dateSelected = null;
    },

    async getDailyStatisticBagByStation() {
      this.dailyStatisticBags = await this.fetchBagStatistics("jour");
    },

    async getAnnualStatisticBagByStation() {
      this.annualStatisticBags = await this.fetchBagStatistics("annuel");
    },

    // FORMAT DE LA DATE (AAAA-MM-JJ -> JJ/MM/AAAA)
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
  },

  mounted() {
    this.getDailyStatisticBagByStation();
    this.getAnnualStatisticBagByStation();
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/admin/ui";

.dbb-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 28px;
}

.dbb-head__date {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: $ov-green;
}

.dbb-head__title {
  margin: 4px 0 2px;
  font-size: 24px;
  font-weight: 900;
  letter-spacing: -0.4px;
  color: $ov-navy;
}

.dbb-head__sub {
  font-size: 13px;
  color: $ov-muted;
}

.dbb-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;

  .ov-select,
  .ov-input {
    width: auto;
    min-width: 170px;
    height: 40px;
    background-color: #ffffff;
  }

  .ov-btn {
    height: 40px;
  }
}

.dbb-section {
  margin-bottom: 36px;
}

.dbb-section__head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.dbb-section__title {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  color: $ov-navy;
}

.dbb-section__close {
  margin-left: auto;
}

@media (max-width: 760px) {
  .dbb-filters {
    width: 100%;

    .ov-select,
    .ov-input,
    .ov-btn {
      flex: 1;
      min-width: 0;
    }
  }
}
</style>
